export const UrlConstants = {
    MODEL: "modelName",
    MODELGROUP: "modelGroupCode",
    MODELGROUPNAME: "modelGroupName",
    RIMLESS: "rimless",
    INSPIRATIONGROUP: "inspirationGroup",
    CATEGORYCODE: "categoryCode",
    GROUPCODE: "groupCode",
	BRANDMODE: "brandMode",
	PRODUCTLINE: 'productLine',
	KIDTEEN: 'kid-teen',
	SPECIAL_EDITION: 'special-edition',
	LIMITED_EDITION_CNY_GOAT: 'limited-edition'
};
